export const initialHomeKVStoresState = {
    kvStoresByHomeIdByKey: {},
    kvStoreKeysByHomeId: {},
};
